<template>
	<div class="page" :style="{height:fixedHeight+'px'}">
		<!-- 头部 -->
		<div class="titleView">
			<el-row style="padding-left:10px;">
				<el-col :span="4">采购批次号: {{detailData.procureNo}}</el-col>
				<el-col :span="4" v-if="detailData.createOperationInfo">采购人: {{detailData.createOperationInfo.userName}}</el-col>
				<el-col :span="4" v-if="detailData.createOperationInfo">申请日期: {{detailData.createOperationInfo.operationTime}}</el-col>
				<el-col :span="4">
					<span v-if="detailData.state == 1">采购状态:采购中</span>
					<span v-if="detailData.state == 3">采购状态:采购完成</span>
					<span v-if="detailData.state == 4">采购状态:采购取消</span>
				</el-col>
				<el-col :span="8" style="text-align: right;">
					<el-button @click="handleUploadClick(2)" size="small">下载报货单</el-button>
					<el-button @click="handleUploadClick(1)" size="small">下载验货单</el-button>
					<el-button @click="handleUploadRecordClick" size="small">下载分拨单</el-button>
					<el-button type="warning" @click="handleBackClick" style="margin-right: 40px;" size="small">返回</el-button>
				</el-col>
			</el-row>
			<el-row style="padding-left:10px;">
				<el-col :span="3" v-if="detailData.procureGoodsList">产品数量: {{detailData.procureGoodsList.length}}</el-col>
				<el-col :span="3">采购数量: {{detailData.count}}</el-col>
				<el-col :span="3">成本总价: {{detailData.sumPrice}}</el-col>
			</el-row>
		</div>
		<!-- tab切换 -->
		<div class="tabs">
			<el-button @click="handleTabClick(-1)" :type="tabIndex == -1?'warning':''" size="small">全部</el-button>
			<el-button v-for="(item,index) in storeTab" :key="index" @click="handleTabClick(index)" :type="tabIndex == index?'warning':''" size="small">{{item}}</el-button>
		</div>
		<!-- 滚动位置 -->
		<div class="scrollView" style="overflow-y: scroll;" ref="scrollView">
			<!-- 全部商品 -->
			<div id="page-1">
				<!-- 商品类 -->
				<div class="shopClass">
					<div class="comH2" @click="showShop = !showShop">
						<div>商品类</div>
						<i class="el-icon-caret-bottom" v-if="showShop"></i>
						<i class="el-icon-caret-top" v-else></i>
					</div>
					<div class="tableWarp" v-if="showShop">
						<el-table ref="allShopTable" :data="shops" tooltip-effect="dark" @selection-change="handleAllShopChange" size="small">
							<el-table-column type="selection" width="55"/>
							<el-table-column :key="1" prop="title" label="商品名称" />
							<el-table-column :key="2" width="50">
								<template slot-scope="scope">
									<el-tag effect="dark" v-if="scope.row.addType == 2" size="small" type="success">采</el-tag>
								</template>
							</el-table-column>
							<el-table-column :key="3" prop="brand" label="品牌" align="center" />
							<el-table-column :key="4" label="供应商" prop="suppliers" width="120">
								<template slot-scope="scope">
									<el-select v-model="scope.row.supplierId" placeholder="请选择" @change="selectDChange(scope.row)" filterable size="small">
										<el-option v-for="item in suppliers" :key="item._id" :label="item.basic_info.name" :value="item._id" />
									</el-select>
								</template>
							</el-table-column>
							<el-table-column :key="5" prop="skuValue" label="规格" align="center" width="120" />
							<el-table-column :key="10" prop="count" label="条码" align="center">
								<template slot-scope="scope">
									<span>{{scope.row.barCode?scope.row.barCode:'--'}}</span>
								</template>
							</el-table-column>
							<el-table-column :key="6" prop="unit" label="单位" align="center" />
							<el-table-column :key="13"  label="成本价" align="center">
								<template slot-scope="scope">
									<span>{{scope.row.validationData?scope.row.validationData.costPrice:'--'}}</span>
								</template>
							</el-table-column>
							<el-table-column :key="7" prop="count" label="采购数量" align="center">
								<template slot-scope="scope">
									<span>{{scope.row.goodsCount == 0?'--':scope.row.goodsCount}}</span>
								</template>
							</el-table-column>
							<el-table-column :key="8" prop="count" label="实收数量" align="center">
								<template slot-scope="scope">
									<span>{{scope.row.validationData == null?'0':scope.row.validationData.paidCount}}</span>
								</template>
							</el-table-column>
							<el-table-column :key="9" prop="count" label="赠品数量" align="center">
								<template slot-scope="scope">
									<span>{{scope.row.validationData == null?'0':scope.row.validationData.givingCount}}</span>
								</template>
							</el-table-column>
							<el-table-column :key="11" prop="validationData.remarks" label="备注" align="center" width="140" size="small">
								<template slot-scope="scope">
									<template v-if="scope.row.addType == 2 && scope.row.procureGoodsState < 3">
										<el-input placeholder="请输入备注" v-model="scope.row.validationData.remarks" @change="remarkChange(scope.row)" size="small"/>
									</template>
									<template v-if="scope.row.addType == 2 && scope.row.procureGoodsState >= 3">
										<div v-if="scope.row.validationData == null">--</div>
										<div v-else>
											<span v-if="scope.row.validationData.remarks == ''">--</span>
											<span v-if="scope.row.validationData.remarks != ''">{{scope.row.validationData.remarks}}</span>
										</div>
									</template>
								</template>
							</el-table-column>
							<el-table-column :key="111" prop="procureGoodsRemark" label="申请单备注" align="center" width="140" size="small">
								<template slot-scope="scope">
									<div v-if="scope.row.shopRquestRemark" style="color: red;">

										<span v-for="(item,index) in scope.row.shopRquestRemark" :key="index">
										{{item.shopInfo.shopName}}:	{{item.rquestRemark}}
										</span>
									</div>
									<div v-else>无</div>
								</template>
							</el-table-column>
							<el-table-column :key="15" label="异常" align="center">
								<template slot-scope="scope">
									<span v-if="scope.row.validationData.abnormalCount == 0">--</span>
									<el-popover v-else placement="top-start" title="异常" width="200" trigger="click" :content="' 漏发:'+scope.row.validationData.abnormalInfo.leakageCount+' 破损:'+scope.row.validationData.abnormalInfo.brokenCount+' 过期:'+scope.row.validationData.abnormalInfo.overdueCount+' 调换:'+scope.row.validationData.abnormalInfo.switchCount+' 无货:'+scope.row.validationData.abnormalInfo.noCount">
										<div slot="reference">异常{{scope.row.validationData.abnormalCount}}<span class="el-icon-view" style="color: #0000FF;"></span></div>
									</el-popover>
								</template>
							</el-table-column>
							<el-table-column :key="14" label="操作" align="center" width="140">
								<template slot-scope="scope">
									<el-button type="text" size="small" @click="handleDeleteClick(scope.row)">删除</el-button>
									<el-button type="text" size="small" v-if="scope.row.procureGoodsState==1" @click="handleInspectionClick(scope.row)">验货</el-button>
									<el-button type="text" size="small" v-if="scope.row.procureGoodsState == 3 || scope.row.procureGoodsState == 2" @click="handleResetGoodsClick(scope.row)">重新验货</el-button>
									<el-button type="text" size="small" v-if="scope.row.procureGoodsState == 3" @click="handleAssignClick(scope.row)">分拨</el-button>
									<el-button type="text" size="small" v-if="scope.row.procureGoodsState >2" @click="handleUpdatePrice(scope.row)">修改成本价</el-button>
									<!-- <el-button type="text" size="small" v-if="scope.row.procureGoodsState > 5" @click="toggleAllShop(scope.row)">查看条码</el-button> -->
								</template>
							</el-table-column>
						</el-table>
						<div class="allNum">
							<div>共{{shopCount}}件</div>
						</div>
					</div>
				</div>
				<!-- 医疗类 -->
				<div class="shopClass" v-if="drugs.length > 0">
					<div class="comH2" @click="showDrug = !showDrug">
						<div>医疗类</div>
						<i class="el-icon-caret-bottom" v-if="showDrug"></i>
						<i class="el-icon-caret-top" v-else></i>
					</div>
					<div class="tableWarp" v-if="showDrug">
						<el-table ref="allDrugTable" :data="drugs" tooltip-effect="dark" @selection-change="handleAllDrugChange" size="small">
							<el-table-column type="selection" width="55"/>
							<el-table-column :key="1" prop="title" label="商品名称" />
							<el-table-column :key="2" width="50">
								<template slot-scope="scope">
									<el-tag effect="dark" v-if="scope.row.addType == 2" size="small" type="success">采</el-tag>
								</template>
							</el-table-column>
							<el-table-column :key="3" prop="brand" label="品牌" align="center" />
							<el-table-column :key="4" label="供应商" width="120">
								<template slot-scope="scope">
									<el-select v-model="scope.row.supplierId" placeholder="请选择" @change="selectDChange(scope.row)" filterable size="small">
										<el-option v-for="item in suppliers" :key="item._id" :label="item.basic_info.name" :value="item._id" />
									</el-select>
								</template>
							</el-table-column>
							<el-table-column :key="5" prop="skuValue" label="规格" align="center" width="120" />
							<el-table-column :key="6" prop="unit" label="单位" align="center" />
							<el-table-column :key="13"  label="成本价" align="center">
								<template slot-scope="scope">
									<span>{{scope.row.validationData?scope.row.validationData.costPrice:'--'}}</span>
								</template>
							</el-table-column>
							<el-table-column :key="7" prop="goodsCount" label="采购数量" align="center">
								<template slot-scope="scope">
									<span>{{scope.row.goodsCount == 0?'--':scope.row.goodsCount}}</span>
								</template>
							</el-table-column>
							<el-table-column :key="8" label="实收数量" align="center">
								<template slot-scope="scope">
									<span>{{scope.row.validationData == null?'0':scope.row.validationData.paidCount}}</span>
								</template>
							</el-table-column>
							<el-table-column :key="9" label="赠品数量" align="center">
								<template slot-scope="scope">
									<span>{{scope.row.validationData == null?'0':scope.row.validationData.givingCount}}</span>
								</template>
							</el-table-column>
							<el-table-column :key="11" prop="procureGoodsRemark" label="备注" align="center" width="140" size="small">
								<template slot-scope="scope">
									<template v-if="scope.row.addType == 2 && scope.row.procureGoodsState < 3">
										<el-input placeholder="请输入备注" v-model="scope.row.validationData.remarks" @change="remarkChange(scope.row)" size="small"/>
									</template>
									<template v-if="scope.row.addType == 2 && scope.row.procureGoodsState >= 3">
										<div v-if="scope.row.validationData == null">--</div>
										<div v-else>
											<span v-if="scope.row.validationData.remarks == ''">--</span>
											<span v-if="scope.row.validationData.remarks != ''">{{scope.row.validationData.remarks}}</span>
										</div>
									</template>
								</template>
							</el-table-column>
							<el-table-column :key="111" prop="procureGoodsRemark" label="申请单备注" align="center" width="140" size="small">
								<template slot-scope="scope">
									<div v-if="scope.row.shopRquestRemark" style="color: red;">
										<span v-for="(item,index) in scope.row.shopRquestRemark" :key="index">
										{{item.shopInfo.shopName}}:	{{item.rquestRemark}}
										</span>
									</div>
									<div v-else>无</div>
								</template>
							</el-table-column>
							<el-table-column :key="15" label="异常" align="center">
								<template slot-scope="scope">
									<span v-if="scope.row.validationData.abnormalCount == 0">--</span>
									<el-popover v-else placement="top-start" title="异常" width="200" trigger="click" :content="' 漏发:'+scope.row.validationData.abnormalInfo.leakageCount+' 破损:'+scope.row.validationData.abnormalInfo.brokenCount+' 过期:'+scope.row.validationData.abnormalInfo.overdueCount+' 调换:'+scope.row.validationData.abnormalInfo.switchCount+' 无货:'+scope.row.validationData.abnormalInfo.noCount">
										<div slot="reference">异常{{scope.row.validationData.abnormalCount}}<span class="el-icon-view" style="color: #0000FF;"></span></div>
									</el-popover>
								</template>
							</el-table-column>
							<el-table-column :key="14" label="操作" align="center" width="140">
								<template slot-scope="scope">
									<el-button type="text" size="small" @click="handleDeleteClick(scope.row)">删除</el-button>
									
									<el-button type="text" size="small" v-if="scope.row.procureGoodsState==1" @click="handleInspectionClick(scope.row)">验货</el-button>
									<el-button type="text" size="small" v-if="scope.row.procureGoodsState == 3 || scope.row.procureGoodsState == 2" @click="handleResetGoodsClick(scope.row)">重新验货</el-button>
									<el-button type="text" size="small" v-if="scope.row.procureGoodsState == 3" @click="handleAssignClick(scope.row)">分拨</el-button>
									<el-button type="text" size="small" v-if="scope.row.procureGoodsState >2" @click="handleUpdatePrice(scope.row)">修改成本价</el-button>
								</template>
							</el-table-column>
	
						</el-table>
						<div class="allNum">
							<div>共{{drugCount}}件</div>
						</div>
					</div>
				</div>
				<!-- 耗材类 -->
				<div class="shopClass" v-if="haocais.length > 0">
					<div class="comH2" @click="showHaocai = !showHaocai">
						<div>耗材类</div>
						<i class="el-icon-caret-bottom" v-if="showHaocai"></i>
						<i class="el-icon-caret-top" v-else></i>
					</div>
					<div class="tableWarp" v-if="showHaocai">
						<el-table ref="allHaocaiTable" :data="haocais" tooltip-effect="dark" @selection-change="handleAllHaocaiChange" size="small">
							<el-table-column type="selection" width="55"/>
							<el-table-column :key="1" prop="title" label="商品名称" />
							<el-table-column :key="2" width="50">
								<template slot-scope="scope">
									<el-tag effect="dark" v-if="scope.row.addType == 2" size="small" type="success">采</el-tag>
								</template>
							</el-table-column>
							<el-table-column :key="3" prop="brand" label="品牌" align="center">
								<template>
									<span>--</span>
								</template>
							</el-table-column>
							<el-table-column :key="4" label="供应商" width="120">
								<template slot-scope="scope">
									<el-select v-model="scope.row.supplierId" placeholder="请选择" @change="selectDChange(scope.row)" filterable size="small">
										<el-option v-for="item in suppliers" :key="item._id" :label="item.basic_info.name" :value="item._id" />
									</el-select>
								</template>
							</el-table-column>
							<el-table-column :key="5" prop="skuValue" label="规格" align="center" width="120">
								<template>
									<span>--</span>
								</template>
							</el-table-column>
							<el-table-column :key="6" prop="unit" label="单位" align="center" />
							<el-table-column :key="13"  label="成本价" align="center">
								<template slot-scope="scope">
									<span>{{scope.row.validationData?scope.row.validationData.costPrice:'--'}}</span>
								</template>
							</el-table-column>
							<el-table-column :key="7" prop="goodsCount" label="采购数量" align="center">
								<template slot-scope="scope">
									<span>{{scope.row.goodsCount == 0?'--':scope.row.goodsCount}}</span>
								</template>
							</el-table-column>
							<el-table-column :key="8" label="实收数量" align="center">
								<template slot-scope="scope">
									<span>{{scope.row.validationData == null?'0':scope.row.validationData.paidCount}}</span>
								</template>
							</el-table-column>
							<el-table-column :key="9" label="赠品数量" align="center">
								<template slot-scope="scope">
									<span>{{scope.row.validationData == null?'0':scope.row.validationData.givingCount}}</span>
								</template>
							</el-table-column>
							<el-table-column :key="11" prop="procureGoodsRemark" label="备注" align="center" width="140" size="small">
								<template slot-scope="scope">
									<template v-if="scope.row.addType == 2 && scope.row.procureGoodsState < 3">
										<el-input placeholder="请输入备注" v-model="scope.row.validationData.remarks" @change="remarkChange(scope.row)" size="small"/>
									</template>
									<template v-if="scope.row.addType == 2 && scope.row.procureGoodsState >= 3">
										<div v-if="scope.row.validationData == null">--</div>
										<div v-else>
											<span v-if="scope.row.validationData.remarks == ''">--</span>
											<span v-if="scope.row.validationData.remarks != ''">{{scope.row.validationData.remarks}}</span>
										</div>
									</template>
								</template>
							</el-table-column>
							<el-table-column :key="111" prop="procureGoodsRemark" label="申请单备注" align="center" width="140" size="small">
								<template slot-scope="scope">
										<div v-if="scope.row.shopRquestRemark" style="color: #0000FF;">
										<span v-for="(item,index) in scope.row.shopRquestRemark" :key="index">
										{{item.shopInfo.shopName}}:	{{item.rquestRemark}}
										</span>
									</div>
									<div v-else>无</div>
								</template>
							</el-table-column>
							<el-table-column :key="15" label="异常" align="center">
								<template slot-scope="scope">
									<span v-if="scope.row.validationData.abnormalCount == 0">--</span>
									<el-popover v-else placement="top-start" title="异常" width="200" trigger="click" :content="' 漏发:'+scope.row.validationData.abnormalInfo.leakageCount+' 破损:'+scope.row.validationData.abnormalInfo.brokenCount+' 过期:'+scope.row.validationData.abnormalInfo.overdueCount+' 调换:'+scope.row.validationData.abnormalInfo.switchCount+' 无货:'+scope.row.validationData.abnormalInfo.noCount">
										<div slot="reference">异常{{scope.row.validationData.abnormalCount}}<span class="el-icon-view" style="color: red;"></span></div>
									</el-popover>
								</template>
							</el-table-column>
							<el-table-column :key="14" label="操作" align="center" width="140">
								<template slot-scope="scope">
									<el-button type="text" size="small" @click="handleDeleteClick(scope.row)">删除</el-button>
									
									<el-button type="text" size="small" v-if="scope.row.procureGoodsState==1" @click="handleInspectionClick(scope.row)">验货</el-button>
									<el-button type="text" size="small" v-if="scope.row.procureGoodsState == 3 || scope.row.procureGoodsState == 2" @click="handleResetGoodsClick(scope.row)">重新验货</el-button>
									<el-button type="text" size="small" v-if="scope.row.procureGoodsState == 3" @click="handleAssignClick(scope.row)">分拨</el-button>
									<el-button type="text" size="small" v-if="scope.row.procureGoodsState > 2" @click="handleUpdatePrice(scope.row)">修改成本价</el-button>
									<!-- <el-button type="text" size="small" v-if="scope.row.procureGoodsState > 5" @click="toggleAllHaocai(scope.row)">查看条码</el-button> -->
								</template>
							</el-table-column>
						</el-table>
						<div class="allNum">
							<div>共{{haocaiCount}}件</div>
						</div>
					</div>
				</div>
			</div>
			<!-- 其他门店商品 -->
			<template v-for="(item,index) in stores">
				<div :id="'page'+index" :key="index">
					<div class="storeName">
						<div @click="handleStoreClick(index)">
							<span>采购门店:{{item.shopInfo.shopName}}</span>
							<i class="el-icon-caret-bottom" v-if="item.isShow" style="color: #1890FF;"></i>
							<i class="el-icon-caret-top" v-else style="color: #1890FF;"></i>
							<span v-for="(storeItem,storeIndex) in item.procureRequestNo" :key="storeIndex"> {{storeItem}}</span>
						</div>
						<div v-if="item.isShow">
							<el-button size="small" type="warning" style="margin-right: 20px;" @click="handlefenbochukuClick(index)">门店出库</el-button>
						</div>
					</div>
					<!-- 商品类 -->
					<div class="shopClass" v-if="item.distributionGoodsList.shop.shops.length > 0 && item.isShow">
						<div class="comH2" @click="handleStoreZLClick(index,1)">
							<div>商品类</div>
							<i class="el-icon-caret-bottom" v-if="item.distributionGoodsList.shop.isShow"></i>
							<i class="el-icon-caret-top" v-else></i>
						</div>
						<div class="tableWarp" v-if="item.distributionGoodsList.shop.isShow">
							<el-table :ref="'shopTable'+index" :data="item.distributionGoodsList.shop.shops" tooltip-effect="dark" @selection-change="handleSelectShop(arguments[0],index)" size="small">
								<el-table-column type="selection" width="55"/>
								<el-table-column :key="1" prop=".title" label="商品名称" />
								<el-table-column :key="2" width="50">
									<template slot-scope="scope">
										<el-tag effect="dark" v-if="scope.row.addType == 2" size="small" type="success">采</el-tag>
									</template>
								</el-table-column>
								<el-table-column :key="3" prop="brand" label="品牌" align="center" />
								<el-table-column :key="4" prop="skuValue" label="规格" align="center" width="120" />
								<el-table-column :key="10" prop="count" label="条码" align="center">
								<template slot-scope="scope">
									<span>{{scope.row.barCode?scope.row.barCode:'--'}}</span>
								</template>
							</el-table-column>
								<el-table-column :key="5" prop="unit" label="单位" align="center" />
								<el-table-column :key="13"  label="成本价" align="center">
								<template slot-scope="scope">
									<span>{{scope.row.validationData?scope.row.validationData.costPrice:'--'}}</span>
								</template>
							</el-table-column>
								<el-table-column :key="6" prop="requestCount" label="采购数量" align="center">
									<template slot-scope="scope">
										<span>{{scope.row.requestCount == 0?'--':scope.row.requestCount}}</span>
									</template>
								</el-table-column>
								<el-table-column :key="7" prop="distributionCount" label="分拨数量" align="center">
									<template slot-scope="scope">
										<span>{{scope.row.distributionCount}}</span>
									</template>
								</el-table-column>
								<el-table-column :key="8" prop="procureGoodsRemark" label="备注" align="center">
									<template slot-scope="scope">
										<div v-if="scope.row.validationData == null">--</div>
										<div v-else>
											<span v-if="scope.row.validationData.remarks == ''">--</span>
											<span v-if="scope.row.validationData.remarks != ''">{{scope.row.validationData.remarks}}</span>
										</div>
									</template>
								</el-table-column>
								<el-table-column :key="9" prop="distributionState" label="门店验收状态" align="center">
									<template slot-scope="scope">
										<template>
											<span v-if="scope.row.distributionState == 0">未出库</span>
											<span v-if="scope.row.distributionState == 1">未验收</span>
											<span v-if="scope.row.distributionState == 2" style="color: red;font-weight: bold;">已验收</span>
										</template>
									</template>
								</el-table-column>
								<el-table-column :key="15" label="异常" align="center">
									<template slot-scope="scope">
										<div>
											<div v-if="scope.row.acceptanceInfo == null">--</div>
											<template v-if="scope.row.acceptanceInfo != null">
												<div v-if="scope.row.acceptanceInfo.abnormalInfo == null">--</div>
												<template v-if="scope.row.acceptanceInfo.abnormalInfo != null">
													<el-popover placement="top-start" title="异常" width="200" trigger="click" :content="' 漏发:'+scope.row.acceptanceInfo.abnormalInfo.leakageCount+' 破损:'+scope.row.acceptanceInfo.abnormalInfo.brokenCount+' 过期:'+scope.row.acceptanceInfo.abnormalInfo.overdueCount+' 调换:'+scope.row.acceptanceInfo.abnormalInfo.switchCount+' 无货:'+scope.row.acceptanceInfo.abnormalInfo.noCount">
														<div slot="reference">异常{{scope.row.acceptanceInfo.abnormalInfo.leakageCount+scope.row.acceptanceInfo.abnormalInfo.brokenCount+scope.row.acceptanceInfo.abnormalInfo.overdueCount+scope.row.acceptanceInfo.abnormalInfo.switchCount+scope.row.acceptanceInfo.abnormalInfo.noCount}}<span class="el-icon-view" style="color: #0000FF;"></span></div>
													</el-popover>
												</template>
											</template>
										</div>
									</template>
								</el-table-column>
							</el-table>
							<div class="allNum">
								<div>申请采购共{{item.distributionGoodsList.shop.allCount}}件</div>
							</div>
						</div>
					</div>
					<!-- 医疗类 -->
					<div class="shopClass" v-if="item.distributionGoodsList.drug.drugs.length > 0 && item.isShow">
						<div class="comH2" @click="handleStoreZLClick(index,2)">
							<div>医疗类</div>
							<i class="el-icon-caret-bottom" v-if="item.distributionGoodsList.drug.isShow"></i>
							<i class="el-icon-caret-top" v-else></i>
						</div>
						<div class="tableWarp" v-if="item.distributionGoodsList.drug.isShow">
							<el-table :ref="'drugTable'+index" :data="item.distributionGoodsList.drug.drugs" tooltip-effect="dark" @selection-change="handleSelectDrug(arguments[0],index)" size="small">
								<el-table-column type="selection" width="55"/>
								<el-table-column :key="1" prop="title" label="商品名称" />
								<el-table-column :key="2" width="50">
									<template slot-scope="scope">
										<el-tag effect="dark" v-if="scope.row.addType == 2" size="small" type="success">采</el-tag>
									</template>
								</el-table-column>
								<el-table-column :key="3" prop="brand" label="品牌" align="center" />
								<el-table-column :key="4" prop="skuValue" label="规格" align="center" width="120" />
								<el-table-column :key="5" prop="unit" label="单位" align="center" />
								<el-table-column :key="13"  label="成本价" align="center">
								<template slot-scope="scope">
									<span>{{scope.row.validationData?scope.row.validationData.costPrice:'--'}}</span>
								</template>
							</el-table-column>
								<el-table-column :key="6" prop="requestCount" label="采购数量" align="center">
									<template slot-scope="scope">
										<span>{{scope.row.requestCount == 0?'--':scope.row.requestCount}}</span>
									</template>
								</el-table-column>
								<el-table-column :key="7" prop="distributionCount" label="分拨数量" align="center">
									<template slot-scope="scope">
										<span>{{scope.row.distributionCount}}</span>
									</template>
								</el-table-column>
								<el-table-column :key="8" prop="remarks" label="备注" align="center">
									<template slot-scope="scope">
										<div v-if="scope.row.validationData == null">--</div>
										<div v-else>
											<span v-if="scope.row.validationData.remarks == ''">--</span>
											<span v-if="scope.row.validationData.remarks != ''">{{scope.row.validationData.remarks}}</span>
										</div>
									</template>
								</el-table-column>
								<el-table-column :key="9" prop="procureGoodsRemark" label="门店验收状态" align="center">
									<template slot-scope="scope">
										<template>
											<span v-if="scope.row.distributionState == 0">未出库</span>
											<span v-if="scope.row.distributionState == 1">未验收</span>
											<span v-if="scope.row.distributionState == 2" style="color: red;font-weight: bold;">已验收</span>
										</template>
									</template>
								</el-table-column>
								<el-table-column :key="15" label="异常" align="center">
									<template slot-scope="scope">
										<div v-if="scope.row.distributions_list == null || scope.row.distributions_list.length == 0">--</div>
										<div v-else>
											<div v-if="scope.row.acceptanceInfo == null">--</div>
											<template v-if="scope.row.acceptanceInfo != null">
												<div v-if="scope.row.acceptanceInfo.abnormalInfo == null">--</div>
												<template v-if="scope.row.acceptanceInfo.abnormalInfo != null">
													<el-popover placement="top-start" title="异常" width="200" trigger="click" :content="' 漏发:'+scope.row.acceptanceInfo.abnormalInfo.leakageCount+' 破损:'+scope.row.acceptanceInfo.abnormalInfo.brokenCount+' 过期:'+scope.row.acceptanceInfo.abnormalInfo.overdueCount+' 调换:'+scope.row.acceptanceInfo.abnormalInfo.switchCount+' 无货:'+scope.row.acceptanceInfo.abnormalInfo.noCount">
														<div slot="reference">异常{{scope.row.acceptanceInfo.abnormalInfo.leakageCount+scope.row.acceptanceInfo.abnormalInfo.brokenCount+scope.row.acceptanceInfo.abnormalInfo.overdueCount+scope.row.acceptanceInfo.abnormalInfo.switchCount+scope.row.acceptanceInfo.abnormalInfo.noCount}}<span class="el-icon-view" style="color: #0000FF;"></span></div>
													</el-popover>
												</template>
											</template>
										</div>
									</template>
								</el-table-column>
							</el-table>
							<div class="allNum">
								<div>申请采购共{{item.distributionGoodsList.drug.allCount}}件</div>
							</div>
						</div>
					</div>
					<!-- 耗材类 -->
					<div class="shopClass" v-if="item.distributionGoodsList.haocai.haocais.length > 0 && item.isShow">
						<div class="comH2" @click="handleStoreZLClick(index,3)">
							<div>耗材类</div>
							<i class="el-icon-caret-bottom" v-if="item.distributionGoodsList.haocai.isShow"></i>
							<i class="el-icon-caret-top" v-else></i>
						</div>
						<div class="tableWarp" v-if="item.distributionGoodsList.haocai.isShow">
							<el-table :ref="'haocaiTable'+index" :data="item.distributionGoodsList.haocai.haocais" tooltip-effect="dark" @selection-change="handleSelectHaocai(arguments[0],index)" size="small">
								<el-table-column type="selection" width="55"/>
								<el-table-column :key="1" prop="title" label="商品名称" />
								<el-table-column :key="2" width="50">
									<template slot-scope="scope">
										<el-tag effect="dark" v-if="scope.row.addType == 2" size="small" type="success">采</el-tag>
									</template>
								</el-table-column>
								<el-table-column :key="3" prop="brand" label="品牌" align="center">
									<template>
										<span>--</span>
									</template>
								</el-table-column>
								<el-table-column :key="4" prop="skuValue" label="规格" align="center" width="120">
									<template>
										<span>--</span>
									</template>
								</el-table-column>
								<el-table-column :key="5" prop="unit" label="单位" align="center" />
								<el-table-column :key="13"  label="成本价" align="center">
								<template slot-scope="scope">
									<span>{{scope.row.validationData?scope.row.validationData.costPrice:'--'}}</span>
								</template>
							</el-table-column>
								<el-table-column :key="6" prop="requestCount" label="采购数量" align="center">
									<template slot-scope="scope">
										<span>{{scope.row.requestCount == 0?'--':scope.row.requestCount}}</span>
									</template>
								</el-table-column>
								<el-table-column :key="7" prop="distributionCount" label="分拨数量" align="center">
									<template slot-scope="scope">
										<span>{{scope.row.distributionCount}}</span>
									</template>
								</el-table-column>
								<el-table-column :key="8" prop="procureGoodsRemark" label="备注" align="center">
									<template slot-scope="scope">
										<div v-if="scope.row.validationData == null">--</div>
										<div v-else>
											<span v-if="scope.row.validationData.remarks == ''">--</span>
											<span v-if="scope.row.validationData.remarks != ''">{{scope.row.validationData.remarks}}</span>
										</div>
									</template>
								</el-table-column>
								<el-table-column :key="9" prop="distributionState" label="门店验收状态" align="center">
									<template slot-scope="scope">
										<template>
											<span v-if="scope.row.distributionState == 0">未出库</span>
											<span v-if="scope.row.distributionState == 1">未验收</span>
											<span v-if="scope.row.distributionState == 2" style="color: red;font-weight: bold;">已验收</span>
										</template>
									</template>
								</el-table-column>
								<el-table-column :key="15" label="异常" align="center">
									<template slot-scope="scope">
										<div v-if="scope.row.distributions_list == null || scope.row.distributions_list.length == 0">--</div>
										<div v-else>
											<div v-if="scope.row.acceptanceInfo == null">--</div>
											<template v-if="scope.row.acceptanceInfo != null">
												<div v-if="scope.row.acceptanceInfo.abnormalInfo == null">--</div>
												<template v-if="scope.row.acceptanceInfo.abnormalInfo != null">
													<el-popover placement="top-start" title="异常" width="200" trigger="click" :content="' 漏发:'+scope.row.acceptanceInfo.abnormalInfo.leakageCount+' 破损:'+scope.row.acceptanceInfo.abnormalInfo.brokenCount+' 过期:'+scope.row.acceptanceInfo.abnormalInfo.overdueCount+' 调换:'+scope.row.acceptanceInfo.abnormalInfo.switchCount+' 无货:'+scope.row.acceptanceInfo.abnormalInfo.noCount">
														<div slot="reference">异常{{scope.row.acceptanceInfo.abnormalInfo.leakageCount+scope.row.acceptanceInfo.abnormalInfo.brokenCount+scope.row.acceptanceInfo.abnormalInfo.overdueCount+scope.row.acceptanceInfo.abnormalInfo.switchCount+scope.row.acceptanceInfo.abnormalInfo.noCount}}<span class="el-icon-view" style="color: #0000FF;"></span></div>
													</el-popover>
												</template>
											</template>
										</div>
									</template>
								</el-table-column>
							</el-table>
							<div class="allNum">
								<div>申请采购共{{item.distributionGoodsList.haocai.allCount}}件</div>
						</div>
					</div>
				</div>
			</div>
			</template>
		</div>
		<!-- 底部按钮 -->
		<div class="fix_btn">
			<div class="fix_btn_l">
				<div>备注:</div>
				<el-input type="textarea" :row="2" placeholder="请输入内容" v-model="remarkTextValue" resize="none"></el-input>
			</div>
			<div class="fix_btn_r">
				<div class="selectView">
					<div class="selectViewName">批量修改供应商</div>
					<el-select v-model="allInspection" placeholder="请选择" @change="handleAllInspectionClick" style="width: 130px;" filterable>
						<el-option v-for="item in suppliers" :key="item._id" :label="item.basic_info.name" :value="item._id" />
					</el-select>
				</div>
				<el-button type="warning" @click="dialogAddShop_state=true">添加商品</el-button>
				<el-button type="warning" @click="handleCarryClick">采购完成</el-button>
			</div>
		</div>

		<!-- 添加商品弹框 -->
		<div v-if="dialogAddShop_state">
			<dialogAddShop @closeOn="dialogAddShop_state = false" :addShopState.sync="dialogAddShop_state" @submit="selectShop" :tree.sync="tree"></dialogAddShop>
		</div>
		
		<!-- 验货弹框 -->
		<div v-if="dialogInspection_state">
			<dialogInspectionNew @refresh="handleRefresh" @closeOn="handleInspecClose" :inSpectionState.sync="dialogInspection_state" :id.sync="id" :inspectionData.sync="inspectionData"></dialogInspectionNew>
		</div>
		<!-- 分拨弹框 -->
		<div v-if="dialogAssign_state">
			<dialogAssign @refresh="handleRefreshAssign" @closeOn="handleAssignClose" :assignState.sync="dialogInspection_state" :id.sync="id" :assignData.sync="assignData"></dialogAssign>
		</div>
		<!-- 打码弹框 -->
		<!-- <div v-if="dialogPrintCode_state">
			<dialogPrintCode @closeOn="handlePrintCodeClose" :assignState.sync="dialogPrintCode_state" :id.sync="id" :printCodeData.sync="printCodeData"></dialogPrintCode>
		</div> -->
		<!-- 分拨出库记录 -->
		<div v-if="dialogRecord_state">
			<dialogRecord @closeOn="handleRecordClose" :recordState.sync="dialogRecord_state" :id.sync="id" :recordData.sync="recordData"></dialogRecord>
		</div>
		<!-- 下载报货单或者验货单 -->
		<div v-if="dialogUpload_state">
			<dialogUpload @closeOn="handleUploadClose" :uploadState.sync="dialogUpload_state" :id.sync="id" :uploadData.sync="uploadData" :uploadType.sync="uploadType" :uploadTitle="uploadTitle"></dialogUpload>
		</div>
		<!-- 条码补码弹框 -->
		<!-- <div v-if="dialogbuCode_state">
			<dialogBuCode @closeOn="handleBuCodeClose" :buCodeState.sync="dialogbuCode_state" :id.sync="id" :buCodeData.sync="buCodeData" :codeType='codeType'></dialogBuCode>
		</div> -->
		
		<el-dialog title="修改成本价" :visible.sync="dialogUpdatePriceVisible" width="300px">
			<div style="text-align: center;">
				<el-input-number v-model="updatePrice" :start='0'></el-input-number>
			</div>
			
			<div slot="footer" class="dialog-footer">
				<el-button @click="dialogUpdatePriceVisible = false" size="small">取 消</el-button>
				<el-button type="warning" @click="handleUpdatePriceClick" size="small">确 定</el-button>
			</div>
		</el-dialog>
	</div>
</template>
<script>
	import { 	caigouSuccess,outbound,addProcureGoods,caigouDetail,moreSupplier,removeProcureGoods,supplierList,returnVerifyn,updateGoodsRemarks} from "@/api/purchaseApiNew.js"
	import caigouFilter from '@/util/caigouFilter.js'
	import dialogAddShop from "../../../components/dialog_addShopCG.vue"
	import dialogInspectionNew from "../../../components/dialog_InspectionNew.vue"
	import dialogAssign from "../../../components/dialog_assignNew.vue"
	// import dialogPrintCode from "../../../components/dialog_printcode.vue"
	import dialogRecord from "../../../components/dialog_record.vue"
	import dialogUpload from "../../../components/dialog_uploadNew.vue"

	// import dialogBuCode from "../../../components/dialog_buCode.vue"
	import axios from 'axios';
	export default {
		components: {
			dialogAddShop,
			dialogInspectionNew,
			dialogAssign,
			// dialogPrintCode,
			dialogRecord,
			dialogUpload,
			// dialogBuCode
		},
		data() {
			return {
				codeType:1,  //1是补码  2是删除条码
				shopList: [],
				dialogFormVisible: false,
				textValue: '',
				fixedHeight: '',
				id: this.$route.query.id, //跳转订单id
				detailData: {}, //订单详情
				sqDate: '', //申请时间
				shops: [], //商品类
				drugs: [], //药品类
				haocais: [],  //耗材类
				showShop: true, //显示商品类
				showDrug: true, //显示药品类
				showHaocai: true, //显示耗材类
				showUpadate: true, //显示修改记录
				shopCount: 0,
				shopPrice: 0,
				drugCount: 0,
				drugPrice: 0,
				haocaiCount: 0,
				haocaiPrice: 0,
				dialogAddShop_state: false, //商品弹框状态
				dialogInspection_state: false, //验货弹框状态
				dialogAssign_state: false, //分拨状态
				// dialogPrintCode_state:false,  //打印条码状态
				dialogRecord_state:false,  //分拨出库状态
				dialogUpload_state:false,  //下载单弹框
				// dialogbuCode_state:false,  //补码弹框
				tabIndex: -1, //tab默认
				storeTab: [], //门店tab切换
				stores:[],  //各个门店列表
				suppliers:[],  //供应商列表
				inspectionData:null, //验货数据
				assignData:null, //分拨数据
				printCodeData:null,  //打码数据
				recordData:null,  //分拨出库数据
				uploadData:null,  //下载单数据
				buCodeData:null, //补码数据
				uploadType:0,  //下载按钮状态
				uploadTitle:'',  //按钮头部
				allInspection:'',  //批量修改供应商
				allSelectShop:[],  //全部选中商品
				allSelectDrug:[],  //全部选中药品
				allSelectHaocai:[],  //全部选中耗材
				endStoreArr:[],  //分拨所选中商品整合
				remarkTextValue:'',  //整体备注
				allCode:[], //全部选中条码
				tree:[{
					id:"602f1e89c904d9db7ccf3c03"
				},{
					id:"602f1e88c904d9db7ccf3bec"
				},{
					id:"6049cf035a0dfcc381f9311a"
				}],
				priceRow:null,
				updatePrice:0,
				dialogUpdatePriceVisible:false,
			}
		},
		mounted() {
			this.fixedHeight = document.documentElement.clientHeight - 76;
			this.getDetailData()
			this.getSuppliersData(); 
		},
		methods: {
			//修改成本价确认按钮
			handleUpdatePriceClick(){
				console.log(11111);
				let params = {
					procureGoodsId: this.priceRow.id,
					costPrice: this.updatePrice
				};
				this.$http.post(process.env.VUE_APP_zichan + '/api/Procurement/UpdateCostPrice',params).then(
					res => {
						if (res.code == 0) {
							this.dialogUpdatePriceVisible = false;
							this.$message({
								type: 'success',
								message: '已修改'
							})
							this.getDetailData()
						}
					})
			},
			//修改成本价
			handleUpdatePrice(row){
				console.log(row)
				this.priceRow = row;
				this.updatePrice = row.validationData.costPrice;
				this.dialogUpdatePriceVisible = true;
			},
			//下载分拨单
			handleUploadRecordClick(){
				console.log(this.detailData);
				axios.get(process.env.VUE_APP_zichan+'/api/Procurement/UpLoadDistribution',{
					params:{
						procureNo:this.detailData.procureNo,
					},
					responseType: 'blob'
				}).then(response => {
					// console.log(response)
						var href = window.URL.createObjectURL(response.data); //创建下载的链接
						var downloadElement = document.createElement('a');
						downloadElement.href = href;
						downloadElement.download = '分拨单导出.xlsx';
						document.body.appendChild(downloadElement);
						downloadElement.click(); //点击下载
						document.body.removeChild(downloadElement); //下载完成移除元素
						window.URL.revokeObjectURL(href); //释放掉blob对象
				}).catch(err => {
						console.log(err)
				})
			},
			//修改备注
			remarkChange(row){
				console.log(row,"beizhu ")
				let pamars = {
					goodsId:row.id,
					remarks:row.validationData.remarks,
				}
				console.log(pamars)
				updateGoodsRemarks(pamars).then((res)=>{
					if(res.code == 0){
						this.$message({
							message:'已添加备注',
							type:'success'
						})
					}
				})
			},
			//返回按钮
			handleBackClick(){
				this.$confirm('是否退出当前页面？', '提示', {
					confirmButtonText: '确定',
					cancelButtonText: '取消',
					type: 'warning'
				}).then(() => {
					this.$router.push({path:'caigouList'})
					let storage = window.sessionStorage
					storage.setItem("cgtabs",1)
				}).catch(() => {
					this.$message({
						type: 'info',
						message: '已取消'
					});          
				});
			},
			//全部商品选择条码
			handleSelectAllpCode(item){
				console.log(item,"全部选中条码")
				if(this.allCode.length > 0){
					for(let j = 0;j<this.allCode.length;j++){
						if(!item.is_check && item.code == this.allCode[j].code){
							this.$message({
								message:'已选择重复条码',
								type:'info'
							})
							return
						}
					}
				}
				item.is_check = !item.is_check;
				if(item.is_check){
					this.allCode.push(item)
				}
				// console.log(this.allCode)
				for(let i = 0;i< this.allCode.length;i++){
					if(!this.allCode[i].is_check){
						this.allCode.splice(i,1)
					}
				}
			},

			//分拨出库
			handlefenbochukuClick(index,row){
				console.log(index,row,'分拨出库')
				let stores = [...this.stores];
				let shop_id = stores[index].shopInfo.shopId;
				this.$confirm('该门店是否分拨出库？', '提示', {
					confirmButtonText: '确定',
					cancelButtonText: '取消',
					type: 'warning'
				}).then(() => {
					let parmars = {
						procureNo:this.id,
						shopId:shop_id
					}
					outbound(parmars).then((res)=>{
						if(res.code  == 0){
							this.$message({
								type: 'success',
								message: '已分拨出库'
							});
							this.getDetailData()
						}
					})
				}).catch(() => {
					this.$message({
						type: 'info',
						message: '暂不分拨出库'
					});          
				});
			},
			//采购完成
			handleCarryClick(){
				this.$confirm('该采购单是否采购完成', '提示', {
					confirmButtonText: '确定',
					cancelButtonText: '取消',
					type: 'warning'
				}).then(() => {
					let parmars = {
						ProcureNo:this.id,
						remark:this.remarkTextValue
					}
					caigouSuccess(parmars).then((res)=>{
						if(res.code == 0){
							this.$message({
								message:'采购完成',
								type:'success'
							})
							this.$router.push({path:'caigouList'})
							let storage = window.sessionStorage
							storage.setItem("cgtabs",1)
						} 
					})
				}).catch(() => {
					this.$message({
						type: 'info',
						message: '暂不操作'
					});          
				});
			},
			//全部商品选中
			handleAllShopChange(val){
				this.allSelectShop = val;
			},
			//全部药品
			handleAllDrugChange(val){
				this.allSelectDrug = val
			},
			//全部耗材
			handleAllHaocaiChange(val){
				this.allSelectHaocai = val
			},
			//批量修改供应商
			handleAllInspectionClick(){
				console.log(this.allInspection)
				console.log(this.allSelectShop,this.allSelectDrug)
				let arr = this.allSelectShop.concat(this.allSelectDrug).concat(this.allSelectHaocai);
				if(arr.length == 0){
					this.$message({
						message: '请选择需要修改商品',
						type: 'warning'
					});
					return
				}
				console.log(arr)
				//获取label;
				let selectName = this.suppliers.find(val=>val._id==this.allInspection).basic_info.name;
				let idArr = [];
				for(let i = 0;i<arr.length;i++){
					idArr.push(arr[i].id)
				}
				let parmars = {
					procureGoodsIds:idArr,
					supplierId:this.allInspection,
					supplierName:selectName
				}
				moreSupplier(parmars).then((res)=>{
					if(res.code == 0){
						this.$message({
							message: '修改成功',
							type: 'success'
						});
						console.log(res,'修改批量')
						this.allInspection = '';
						this.getDetailData()
					}
				})
				
			},
			//单个修改供应商
			selectDChange(row){
				let idArr = [];
				let selectName = this.suppliers.find(val=>val._id==row.supplierId).basic_info.name;
				console.log(selectName)
				idArr.push(row.id)
				let parmars = {
					procureGoodsIds:idArr,
					supplierId:row.supplierId,
					supplierName:selectName
				}
				moreSupplier(parmars).then((res)=>{
					
					if(res.code == 0){
						this.$message({
							message: '修改成功',
							type: 'success'
						});
						this.allInspection = '';
						this.getDetailData()
					}
				})
			},
			//table子项商品
			handleSelectShop(val,index){
				console.log(val,index)
				this.endStoreArr[index].distributionGoodsList.shop.shops = val 
				console.log(this.endStoreArr[index])
			}, 
			//table子项医疗
			handleSelectDrug(val,index){
				console.log(val,index)
				this.endStoreArr[index].distributionGoodsList.drug.drugs = val 
			}, 
			//table子项耗材
			handleSelectHaocai(val,index){
				console.log(val,index)
				this.endStoreArr[index].distributionGoodsList.haocai.haocais = val 
			},
			//重构日期
			FormatDate(item){
				let time = new Date(item*1000) 
				let year = time.getFullYear()
				let month = time.getMonth() + 1<10?'0'+(time.getMonth() + 1):time.getMonth() + 1
				let date = time.getDate()<10?'0'+time.getDate():time.getDate()
				return year+'-'+month+'-'+date
			},
			//刷新列表
			handleRefresh(){
				this.dialogInspection_state = false
				this.getDetailData()
			},
			//刷新列表
			handleRefreshAssign(){
				this.dialogAssign_state = false;
				this.getDetailData()
			},
			//重新验货
			handleResetGoodsClick(row){
				let parmars = {
					procureGoodsId:row.id
				}
				returnVerifyn(parmars).then((res)=>{
					console.log(res)
					if(res.code == 0){
						this.dialogInspection_state = true
						this.inspectionData = row
					}
				})
			},
			// handleprintClose(val){
			// 	this.dialogPrintCode_state = val
			// },
			
			//关闭打码弹框
			// handlePrintCodeClose(val){
			// 	this.dialogPrintCode_state = val;
			// 	this.getDetailData()
			// },
			//关闭分拨弹框
			handleAssignClose(val){
				this.dialogAssign_state = val
			},
			//分拨按钮
			handleAssignClick(row){
				this.dialogAssign_state = true
				
				this.assignData = row
			},
			//关闭分拨出库弹框
			handleRecordClose(val){
				this.dialogRecord_state = val
			},
			//下载验货单和下载报货单按钮
			handleUploadClick(type){
				if(type == 1){
					this.uploadType = type;
					this.uploadTitle = '下载验货单';
				}else if(type == 2){
					this.uploadType = type
					this.uploadTitle = '下载报货单';
				}
				this.dialogUpload_state = true
				this.uploadData = this.detailData
				console.log( this.detailData,' this.detailData-----');
			},
			//关闭下载
			handleUploadClose(val){
				this.dialogUpload_state = val
			},
			//分拨出库按钮
			handleRecordClick(){
				if(this.detailData.procure_distributions.length == 0){
					this.$message({
						message:'暂无分拨出库记录',
						type:"warning"
					})
					return;
				}
				this.dialogRecord_state = true
				this.recordData = this.detailData
			},
			//关闭验货弹框
			handleInspecClose(val){
				this.dialogInspection_state = val;
				this.getDetailData()
			},
			//验货按钮
			handleInspectionClick(row){
				console.log(row,'验货')
				if(row.supplierId == null){
					this.$message({
						message:'请选择供应商后，再进行验货',
						type:'warning'
					})
					return
				}
				this.dialogInspection_state = true
				this.inspectionData = row
			},
			//分拨前-门店数据
			getStoreStartData() {
				
				let stores = [...this.detailData.shopDistributionResponseList];
				console.log('门店信息',stores)
				let arr = [];
				let shops = [];
				let drugs = [];
				let haocais = [];
				if (stores.length != 0) {
					for (let i = 0; i < stores.length; i++) {
						// 获取tab切换
						if (stores[i].shopInfo.shopId == '5e9412e0b2bfbc089daerr12') {
							arr.push('金水区店')
						} else if (stores[i].shopInfo.shopId == '5e9412e0b2bfbc089daerr18') {
							arr.push('郑东新区店')
						} else if (stores[i].shopInfo.shopId == '5e9412e0b2bfbc089daerr17') {
							arr.push('线上旗舰店')
						} else if (stores[i].shopInfo.shopId == '5e9412e0b2bfbc089daerr14') {
							arr.push('指挥中心店')
						} else if (stores[i].shopInfo.shopId == '5e9412e0b2bfbc089daerr10') {
							arr.push('驯养中心')
						} else if (stores[i].shopInfo.shopId == '5e9412e0b2bfbc089daerr11') {
							arr.push('小程序')
						}
						shops = [];
						drugs = [];
						haocais = [];
						console.log(stores[0],"????")
						//重组商品列表
						for(let j = 0; j<stores[i].distributionGoodsList.length;j++){
							if(stores[i].distributionGoodsList[j].goodsType == '0'){
								shops[j] = stores[i].distributionGoodsList[j]
							}else if(stores[i].distributionGoodsList[j].goodsType == '1'){
								drugs[j] =  stores[i].distributionGoodsList[j]
							}else if(stores[i].distributionGoodsList[j].goodsType == '7'){
								haocais[j] =  stores[i].distributionGoodsList[j]
							}
							shops = shops.filter(item => item);
							drugs = drugs.filter(item => item);
							haocais = haocais.filter(item => item);
						}
						// console.log(shops,drugs)
						stores[i].distributionGoodsList = {
							shop:{
								shops:shops,
								isShow:true,
								allCount:this.getStoreAllData(shops).requestCount,
								// paidcount:this.getStoreAllData(shops).paidcount
							},
							drug:{
								drugs:drugs,
								isShow:true,
								allCount:this.getStoreAllData(drugs).requestCount,
								// paidcount:this.getStoreAllData(drugs).paidcount
							},
							haocai:{
								haocais:haocais,
								isShow:true,
								allCount:this.getStoreAllData(haocais).requestCount,
								// paidcount:this.getStoreAllData(drugs).paidcount
							}
						}
						//添加显示状态
						stores[i].isShow = true;
						this.stores = stores;
					}
					this.storeTab = arr;
					this.stores = stores;
					console.log('门店数据',this.stores)
				}
			},
			//分拨后门店整合数据
			getStoreEndData(){
				let stores = [...this.detailData.shopDistributionResponseList];
				console.log(stores,'stores,store')
				let endArr = [];
				for(let i = 0; i<stores.length;i++){
					endArr[i]={};
					endArr[i].isShow = true;
					endArr[i].distributionGoodsList = {};
					endArr[i].distributionGoodsList.drug = {};
					endArr[i].distributionGoodsList.drug.isShow = true;
					endArr[i].distributionGoodsList.drug.drugs = [];
					endArr[i].distributionGoodsList.shop = {};
					endArr[i].distributionGoodsList.shop.isShow = true;
					endArr[i].distributionGoodsList.shop.shops = [];
					endArr[i].distributionGoodsList.haocai = {};
					endArr[i].distributionGoodsList.haocai.isShow = true;
					endArr[i].distributionGoodsList.haocai.haocais = []
					endArr[i].companyInfo= stores[i].companyInfo
				}
				this.endStoreArr = [...endArr]
				console.log('分拨后整合',endArr)
			},
			//获取门店合计
			getStoreAllData(arr){
				console.log('门店合计',arr)
				let requestCount = 0;
				for(let k =0; k<arr.length;k++){
			
					requestCount = (requestCount +arr[k].requestCount)
				}
				let obj = {
					requestCount:requestCount,
				}
				return obj
			},
			//显示或者隐藏对应门店
			handleStoreClick(index){
				let stores = this.stores;
				stores[index].isShow = !stores[index].isShow;
				this.stores = stores
				this.$set(this.stores,index,this.stores[index])
				console.log(stores)
			},
			//显示或者隐藏对应门店的子类
			handleStoreZLClick(index,type){
				let stores = this.stores;
				console.log(index,type,stores[index])
				if(type == 1){
					stores[index].distributionGoodsList.shop.isShow = !stores[index].distributionGoodsList.shop.isShow;
				}else if(type == 2){
					stores[index].distributionGoodsList.drug.isShow = !stores[index].distributionGoodsList.drug.isShow;
				}else if(type == 3){
					stores[index].distributionGoodsList.haocai.isShow = !stores[index].distributionGoodsList.haocai.isShow;
				}
				this.stores = stores
				this.$set(this.stores,index,this.stores[index])
			},
			//tab切换
			handleTabClick(index) {
				console.log(index)
				this.tabIndex = index;
				let PageId = document.querySelector('#page' + index);
				let indexPageTop = document.querySelector('#page-1').offsetTop;
				// console.log(PageId.offsetTop)
				this.$refs['scrollView'].scrollTo({
					'top': PageId.offsetTop - indexPageTop,
					'behavior': 'smooth'
				})
			},
			//添加商品
			handleAddgoodsClick() {
				this.dialogAddShop_state = true
				this.addGoodsType = false
			},
			//添加商品组件选择事件
			selectShop(row) {
				let shops = this.shops;
				let drugs = this.drugs;
				let haocais = this.haocais;
				if (row.goodsType == 1) {
					if (drugs != undefined) {
						let parmars = {
							procuretNo: this.id,
							procureGoods: {
								goodsId: row.goodsItem.medical_id,
									title: row.goodsItem.title,
									skuId:	'',
									skuValue: row.goodsItem.old_packinfo_info.sku_value,
									goodsType: 1,
									brand:row.goodsItem.brand_name,
									times:row.goodsItem.medical_ext_info.use_times,
									unit:row.wayItem,
									unitId:row.wayItem,
								procureGoodsRemark: "",
							}
						}
						console.log(parmars)
						addProcureGoods(parmars).then((res) => {
							if (res.code == 0) {
								this.$message({
									message: '新增药品',
									type: 'success'
								})
								this.getDetailData()
							}
						})
					}
				} else if (row.goodsType == 0) {
					console.log('选取商品')
					if (shops != undefined) {
						if (!this.addGoodsType) {
							console.log('添加新商品',row)
							let parmars = {
								procuretNo: this.id,
								procureGoods: {
									goodsId: row.goodsItem.goodsId,
										title: row.goodsItem.title,
										skuId: row.skuItem._id,
										skuValue: row.skuItem.skus_name,
										goodsType: 0,
										brand:row.goodsItem.brand_name,
										times:1,
										packing_way_id:row.wayItem.packing_way_id,
										unit:row.wayItem.packing_way_name,
										unitId:row.wayItem.packing_way_id,
									  goodsCount: 0,
									  barCode:row.skuItem.barcode,
									procureGoodsRemark: "",
								}
							}
							console.log(parmars)
							addProcureGoods(parmars).then((res) => {
								if (res.code == 0) {
									this.$message({
										message: '新增商品',
										type: 'success'
									})
									this.getDetailData()
								}
							})
						}
					}
				}else if (row.goodsType == 7) {
					console.log('选取耗材')
					if (haocais != undefined) {
						if (!this.addGoodsType) {
							console.log('添加新耗材')
							let parmars = {
								procuretNo: this.id,
								procureGoods: {
									goodsId: row.goodsItem.consumablematerial_id,
										title: row.goodsItem.title,
										skuValue: '',
										goodsType: 7,
										brand:'',
										times:row.skuItem.use_times,
										packing_way_id:'',
										unit:row.goodsItem.packing_unit,
										unitId:row.goodsItem.packing_unit,
									procureGoodsRemark: "",
								}
							}
							console.log(parmars)
							addProcureGoods(parmars).then((res) => {
								if (res.code == 0) {
									this.$message({
										message: '新增耗材',
										type: 'success'
									})
									this.getDetailData()
								}
							})
						}
					}
				}
			},
			// 删除按钮
			handleDeleteClick(row) {
				this.$confirm('确认要删除这条信息吗?', {
					confirmButtonText: '确定',
					cancelButtonText: '取消',
					type: 'warning'
				}).then(() => {
					let params = {
						procureGoodsId: row.id
					};
					removeProcureGoods(params).then(
						res => {
							if (res.code == 0) {
								this.$message({
									type: 'warning',
									message: '已删除'
								})
								this.getDetailData()
							}
						})
				}).catch(() => {
					this.$message({
						type: 'info',
						message: '已取消删除'
					})
				})
			},
			//获取采购
			getSuppliersData(){
				let parmars = {
					pageIndex:1,
pageSize:100,
appShowStatus:false,
keywords:''
				}
				supplierList(parmars).then((res)=>{
					if(res.code == 0){
						console.log('供应商列表111',res.data);
						this.suppliers = res.data.data;
					}
				})
			},
			//获取详情
			getDetailData() {
				let parmars = {
					id: this.id
				}
				console.log(this.id,'thius.id');
				caigouDetail(parmars).then((res) => {
					if (res.code == 0) {
						console.log('商品详情', res.data)
						this.detailData = res.data;
						let detail = res.data;
						let shopList = []; //商品列表
						let drugList = []; //药品列表
						let haocaiList = [];  //耗材列表
						if(detail.procureGoodsList.length != 0){
							this.getStoreStartData(); //获取门店信息
							this.getStoreEndData();  //分拨后门店数据整合
							for (let i = 0; i < detail.procureGoodsList.length; i++) {
								if (detail.procureGoodsList[i].goodsType == 0) {
									shopList[i] = detail.procureGoodsList[i]
								} else if (detail.procureGoodsList[i].goodsType == 1) {
									drugList[i] = detail.procureGoodsList[i]
								}else if (detail.procureGoodsList[i].goodsType == 7) {
									haocaiList[i] = detail.procureGoodsList[i]
								}
								this.shops = shopList.filter(item => item);
								this.drugs = drugList.filter(item => item);
								this.haocais = haocaiList.filter(item => item);
								this.getAllData()
							}
						}else{
							this.shops = [];
							this.drugs = [];
							this.haocais = [];
							this.endStoreArr = [];
							this.storeTab = [];
							this.stores = [];
						}
						
					}
				})
			},
			// 获取总合计
			getAllData() {
				// console.log('商品列表', this.shops)
				// console.log('药品列表', this.drugs)
				let shops = this.shops;
				let drugs = this.drugs;
				let haocais = this.haocais;
				let shopCount = 0;
				let drugCount = 0;
				let haocaiCount = 0;
				if (shops.length > 0) {
					for (let i = 0; i < shops.length; i++) {
						// console.log(shops[i].goodsCount)
						shopCount = (shopCount + shops[i].goodsCount);
					}
					this.shopCount = shopCount;
				}
				if (drugs.length > 0) {
					for (let j = 0; j < drugs.length; j++) {
						drugCount = (drugCount + drugs[j].goodsCount);
					}
					this.drugCount = drugCount;
				}
				if (haocais.length > 0) {
					for (let k = 0; k < haocais.length; k++) {
						haocaiCount = (haocaiCount + haocais[k].goodsCount);
					}
					this.haocaiCount = haocaiCount;
				}
			},
		}
	}
</script>
<style lang="scss" scoped>
	.page {
		display: flex;
		flex-direction: column;
		// 重复头部
		.titleView {
			// width: 98%;
			width: 99%;
			padding: 20px 0;
			// padding-left: 10px;
			margin: 0 auto;
			font-size: 14px;
			color: #2A2A2A;
			background: #fff;
			border-radius: 6px;
		}

		.scrollView {
			flex: 1;
			.storeName{
				font-size: 20px;
				color: #1890FF;
				line-height: 64px;
				font-weight: bold;
				display: flex;
				justify-content: space-between;
				align-items: center;
				div:nth-of-type(1){
					margin-left: 20px;
				}
			}
			.codeView{
				background: #EBF4FF;
				color: #3C3C3C;
				overflow: hidden;
				padding: 10px;
				.shopViewName{
					font-size: 18px;
					line-height: 32px;
				}
				.validView{
					overflow: hidden;
					.validViewName{
						font-size: 16px;
						line-height: 30px;
					}
					.active{
						background: #18A44C !important;
						color: #fff !important;
					}
					.codes{
						padding: 0 5px;
						font-size: 14px;
						border: solid 1px #e9e9eb;
						background: #f4f4f5;
						color: #909399;
						line-height: 22px;
						float: left;
						margin-right: 14px;
						margin-bottom: 6px;
					}
					.codes1{
						padding: 0 5px;
						font-size: 14px;
						border: solid 1px #e9e9eb;
						background: #f4f4f5;
						color: #6CDA35;
						line-height: 22px;
						float: left;
						margin-right: 14px;
						margin-bottom: 6px;
					}
				}
			}
		}

		//重复标题
		.comH2 {
			line-height: 64px;
			font-size: 18px;
			display: flex;
			align-items: center;
		}

		.comH2 div {
			margin-left: 20px;
			margin-right: 6px;
			font-weight: bold;
		}

		.comH2 img {
			width: 16px;
			height: 16px;
			background: red;
		}

		.tableWarp {
			border-radius: 6px;
			background: #fff;
			padding: 20px 30px;

			.tableName {
				line-height: 46px;
				background: #F7F6F9;
				font-size: 18px;
				color: #2A2A2A;
				font-weight: bold;
				margin-bottom: 10px;
			}

			.allNum {
				font-size: 14px;
				background: #F5F5F5;
				height: 50px;
				display: flex;
				align-items: center;
				padding-left: 20px;

				div:nth-of-type(1) {
					margin-right: 20px;
				}
			}
		}

		.fix_btn {
			width: 100%;
			height: 72px;
			background: #fff;
			display: flex;
			align-items: center;
			justify-content: space-between;
			align-items: center;
			.fix_btn_l{
				margin-left: 20px;
				display: flex;
				align-items: center;
				div:nth-of-type(1){
					width: 60px;
				}
			}
			.fix_btn_r{
				display: flex;
				align-items: center;
				button {
					margin-right: 10px;
				}
				
				button:nth-of-type(5) {
					margin-right: 60px;
				}
				.selectView{
					display: flex;
					align-items: center;
					margin-right: 20px;
					.selectViewName{
						margin-right: 10px;
					}
				}
			}
			
		}

		.tabs {
			margin-top: 10px;
			padding: 10px 0;
			background: #fff;

			button {
				margin-left: 20px;
			}
		}
	}
</style>
